export default [
  { title: "eSignature API 101", icon: "", link: "/docs/e-sign" },
  { title: "Authentication", icon: "", link: "/docs/authentication" },
  { title: "Status and error codes", icon: "", link: "/docs/status-and-error-codes/" },
  { title: "API Dashboard", icon: "", link: "/docs/api-dashboard" },
];
